import React, { useEffect, useState } from 'react';
// import { Container, Typography, FormControl, InputLabel, Input, Box, FormGroup, Button } from '@material-ui/core';
import { Navigate, useNavigate, useParams } from "react-router-dom";
import {serviceGetDoctor, serviceAddDoctor} from  "../Services/Service";

const initialValue = {
    firstName:"",
    lastName:"",
    mobile: "",
    email:"",
    btnValue: "",
    action:"",
    updateId:""
}

const DoctorAdd = () => {

    const [formData, setFormData] = useState(initialValue);
    const {firstName,lastName,email,action,mobile } = formData;

    const [isvalid, setIsvalid] = useState(true);
    
    const [formErrors, setFormErrors] = useState('');
    const [headTitle, setHeadTitle] = useState([]);

    const navigate = useNavigate();
    const { id } = useParams();
    
    const [alertInfo, setAlertInfo] = useState({
        visible : false,
        cls : '',
        msg :''
      });
    const onShowAlert = (msg,visible,clas)=>{
        setAlertInfo({...alertInfo, ['visible']: visible,['cls']:clas,['msg']: msg});
    }

    useEffect(() => {
        // fetchAreaClinicDr();
        if(id != '' && id !== undefined){
            setHeadTitle('Update Lead Doctor');
            loadUserData();
        }else{
            setHeadTitle('Add Lead Doctor');
             setFormData({...formData, ['btnValue']: 'Submit',['action']: 'add'});
        }
        
    },[]);

    const loadUserData = async () =>{
        
        const response = await serviceGetDoctor(id);
        setFormData({...formData, ['btnValue']: 'Update',['action']: 'update',['updateId']: id,['firstName']: response.data.data.doctor[0].firstName,['lastName']: response.data.data.doctor[0].lastName,['email']: response.data.data.doctor[0].email,['mobile']: response.data.data.doctor[0].mobile});
        // onShowAlert();
    }

   

    const onValueChange = (e) =>
    {
        if(e.target.name == "mobile"){
            e.target.value =  e.target.value.replace(/\D/g, "");
        }
        setFormData({...formData, [e.target.name]: e.target.value});
    }

    
    function validateForm(){

        if(mobile.length!=10){
            setFormErrors('please Enter 10 digit Mobile No.');
            // isvalid = false;
            setIsvalid(false);
        } 
        
        if(isvalid){
            setIsvalid(true);
            setFormErrors('');
        }   
        return isvalid;   
    }
    const submitHandle = e => {
        e.preventDefault();
        
        let isvalidForm = validateForm();
        if(isvalidForm && isvalid){
            
            serviceAddDoctor(formData)
                .then((response) => {
  
                    if(typeof(response)!=='undefined'){
                        let clas = (response.data.status == "1") ? 'success' : 'danger';
                        if(response.data.status == "1" && formData.action=='add'){
                            setFormData({...formData, ['firstName']: '', ['lastName']: '', ['email']: '', ['mobile']:''});
                        }
                        onShowAlert(response.data.data.message,true,clas);    
                    }
                })
        }else{
            console.log('isvalid false');
        }
             
    }

    return (
        <>
            <section className='projects-section'>
            <div className='row'>
                <h1 className='title mb-4'>{headTitle}</h1>
                {alertInfo.visible ? <div className={"alert alert-"+ alertInfo.cls +" col-md-4 mb-2"} role="alert">{alertInfo.msg}</div> : null}

                {formErrors!='' ? <div className={"alert alert-danger col-md-4"} role="alert">{formErrors}</div> : null}
                

                <form onSubmit={submitHandle} className=''>
                
                <div className="clearfix"></div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example1" className="form-control" required name="firstName" value={firstName} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">First Name</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example1" className="form-control" name="lastName" value={lastName} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Last Name</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="text" id="form2Example3" className="form-control" required name="mobile" maxLength="10" value={mobile} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Mobile</label>
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-floating mb-3">
                        <input type="email" id="form2Example1" className="form-control" required name="email" value={email} onChange={(e) => onValueChange(e)} />
                        <label className="form-label">Email</label>
                    </div>
                </div>

                
                <div className="clearfix"></div>
                <div className="col-md-6 mt-3">
                    <button type="submit" className="btn btn-primary btn-login mb-4" name="btnValue">{formData.btnValue}</button>
                </div>
                    
                </form>
                </div>

</section>

        </>
    )
}


export default DoctorAdd;